<template>
  <div class="padded" style="text-align: left;">

    <edit-pane
    v-if="!hidePanel"
    ref="ep"
    prefix="Structure: "
    :title="(struct.name ? struct.name : (struct.category + ' ' + struct.type) )"
    :editable="isTowerSupplierCo() || isManager('project|maintenance')"
    :deletable="(isTowerSupplierCo() || isManager('management')) && ((struct.site && struct.site.status !== 'Active' ? true : false)) || !struct.structure_id"
    :is-edit="editMode"
    @save="onSave"
    @cancel="onCancel"
    @delete="deleteStruct"
    @edit="onEdit"
    @add="onSave" />

    <br />

    <el-form :model="struct" label-position="left" label-width="120px">

    <el-row :gutter="12">
      <el-col :span="24"> <!-- :sm="24" :md="20" :lg="21" -->

        <el-tabs v-model="menu">

          <el-tab-pane v-if="isTowerSupplierCo() || canAccess('project|maintenance|management')" name="struct">
            <span slot="label"><i class="fa fa-pencil-ruler"></i> {{siteId ? 'Structure' : 'Design'}}</span>
            <el-form label-position="left" label-width="10em" inline>

               <el-row :gutter="24">
                 <!-- Structure Type -->
                 <el-col :lg="siteId ? 12 : 24" :md="24">

                   <el-card shadow="hover">
                     <div slot="header" class="clearfix">
                       <span>Structure Details:</span>
                     </div>

                     <div v-if="siteId">
                       <select-structure v-if="isAdding || isManager('project|management')" v-model="struct.structure_id" label="Structure" :disabled="disabled && canAccess('project|management') && isTowerCo()" />
                     </div>
                     <div v-else>
                       <el-row :gutter="12">
                         <el-col :span="8">
                           <text-input label="Type" v-model="struct.type" :disabled="disabled" />
                         </el-col>
                         <el-col :span="8" v-if="struct.subType || !disabled">
                           <text-input label="subType" v-model="struct.subType" :disabled="disabled" />
                         </el-col>
                         <el-col :span="8" v-if="struct.variant || !disabled">
                           <text-input label="Variant" v-model="struct.variant"  :disabled="disabled" />
                         </el-col>
                       </el-row>
                     </div>

                     <text-input v-if="!siteId" label="Default Heights" v-model="struct.defaultHeights" suffix="m." :disabled="disabled" />
                     <integer-input label="Height" v-model="struct.height" suffix="m." :disabled="disabled" />
                     <el-form-item v-if="!disabled && siteId && struct.design && struct.design.defaultHeights" label="Default Heights">
                       <i><b>{{struct.design.defaultHeights}}</b></i>
                     </el-form-item>
                     <float-input label="Max. Weight" icon="fa fa-weight" v-model="struct.weight" suffix="kg." :decimals="2" :disabled="disabled" />

                   </el-card>
                   <br />
                 </el-col>


                 <!-- Dimensions -->
                 <el-col v-if="(struct.depth || struct.width) || !disabled" :lg="siteId ? 12 : 24" :md="24">
                     <el-card shadow="hover">
                       <div slot="header" class="clearfix">
                         <span>Site Area:</span>
                       </div>
                       <integer-input label="Depth" v-model="struct.depth" suffix="m." :disabled="disabled" />
                       <integer-input label="Width" v-model="struct.width" suffix="m." :disabled="disabled" />
                     </el-card>
                     <br />
                 </el-col>
               </el-row>

              <el-row v-if="(isTowerSupplierCo() || (isTowerCo() && canAccess('project|maintenance')))" :gutter="24">

                   <!-- Structure Design -->
                   <el-col :span="24" v-if="(struct.sharers || struct.levels || struct.power || struct.life) || !disabled">
                       <el-card shadow="hover">
                         <div slot="header" class="clearfix">
                           <span>Structure Design:</span>
                         </div>

                         <integer-input label="Max. Sharers" icon="fa fa-users" v-model="struct.sharers" :disabled="disabled" />
                         <integer-input label="Max. Levels" icon="fa fa-layer-group" v-model="struct.levels" :disabled="disabled" />

                         <float-input label="Power" icon="fa fa-plug" v-model="struct.power" suffix="kwH" :decimals="2" :disabled="disabled" />
                         <integer-input label="Design Life" icon="fa fa-calendar-alt" v-model="struct.life" suffix="years" :disabled="disabled" />
     <!--                    <struct-info label="Standard" icon="fa fa-book" v-model="struct.standard"  :design-value="struct.design.standard" :disabled="disabled" /> -->
                       </el-card>
                       <br />
                   </el-col>
                 </el-row>
               </el-form>

               <hr />

               <h4><i class="fa fa-paperclip"></i> Attachments</h4>
               <files-panel v-if="siteId" :id="siteId" type="site" process="struct" :process-id="struct.id" :max-files="5" :read-only="readOnly" />
               <files-panel v-else :id="struct.id" type="struct" :read-only="readOnly"  />

          </el-tab-pane>


          <el-tab-pane name="struct-supplier">
            <span slot="label"><i class="fa fa-tower-cell"></i> Supplier</span>

            <el-row>
              <el-col :span="20">
                <select-tower-supplier
                  v-if="this.isTowerCo() && (isAdding || !struct.supplier_id || isSuper())"
                  v-model="struct.supplier_id"
                  :disabled="disabled && canAccess('project|maintenance|finance')" @change="supplierUpdated" />
              </el-col>
            </el-row>

            <!-- Structure Supplier -->
            <el-row v-if="supplier">
              <el-col :span="24">
                <el-row v-if="supplier.name">
                  <el-col :span="22" :offset="1">
                    <el-form-item label="Name">
                      <b>{{supplier.name}}</b>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row v-if="supplier.address">
                  <el-col :span="22" :offset="1">
                    <el-form-item label="Address">
                      <b>{{supplier.address}}</b>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row v-if="supplier.postCode">
                  <el-col :span="22" :offset="1">
                    <el-form-item label="Post Code">
                      <b>{{supplier.postCode}}</b>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row v-if="supplier.phone">
                  <el-col :span="22" :offset="1">
                    <el-form-item label="Phone">
                      <a :href="'tel:' + supplier.phone">{{supplier.phone}}</a>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row v-if="supplier.email">
                  <el-col :span="22" :offset="1">
                    <el-form-item label="E-mail">
                      <div v-if="siteId && site">
                        <strong><a :href="'mailto:' + supplier.email + '?subject=RE: Tower Site ' + site.siteName + ' (' + site.siteId + ')'">{{supplier.email}}</a></strong>
                      </div>
                      <div v-else>
                        <strong><a :href="'mailto:' + supplier.email + '?subject=RE: ' + struct.name + ' for ' + clientName">{{supplier.email}}</a></strong>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>

              </el-col>
            </el-row>
            <el-row v-else>
<!--
              <el-col :span="20">
                <select-tower-supplier
                  v-if="this.isTowerCo()"
                  v-model="struct.supplier_id"
                  :disabled="disabled && canAccess('project|maintenance|finance')" @change="supplierUpdated" />
              </el-col>
-->
            </el-row>

          </el-tab-pane>


          <el-tab-pane name="struct-remarks"  v-if="canAccess('project|maintenance|finance')">
            <span slot="label"><i class="fa fa-comment-alt"></i> Remarks</span>
            <h4>Remarks</h4>

            <html-input label="" v-model="struct.remarks" :disabled="disabled" />
          </el-tab-pane>

        </el-tabs>
      </el-col>
    </el-row>

    <div v-if="struct.updated_at">
      <hr />
      <span v-if="isManager('project|management')">
        <el-button type="danger" circle size="small" @click="deleteStruct"><i class="fa fa-trash"></i></el-button>
      </span>
      <span class="pull-right">Last update: <b>{{formatFriendlyDate(struct.updated_at)}}</b><span v-if="struct.updated_by"> by {{struct.updated_by}}</span></span>
    </div>

  </el-form>

  </div>
</template>

<script>

import Vue from 'vue'
import VueEvents from 'vue-events'

Vue.use(VueEvents)

import DateMixins from '@/mixins/DateMixins'
import PostMixins from '@/mixins/PostMixins'

import SelectStructure from '@/components/atoms/selects/SelectStructure'
import SelectTowerSupplier from '@/components/atoms/selects/SelectTowerSupplier'

export default {

  mixins: [DateMixins, PostMixins],

  components: {
    SelectStructure,
    SelectTowerSupplier
  },


  props: {

    rowData: {
      type: Object,
      default: null
    },

    editMode: {
      type: Boolean,
      default: false
    },

    siteId: {
      type: Number,
      default: null
    },

    index: {
      type: Number,
      default: 0
    },

    tableRef: {
      type: String,
      default: 'structtable'
    },

    adding: {
      type: Boolean,
      default: false
    },

    hidePanel: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },



  methods: {

    success (data) {
      this.struct = data

      if (this.isAdding && this.struct && this.struct.design) {
        this.struct.depth = this.struct.design.depth
        this.struct.width = this.struct.design.width
        this.struct.weight = this.struct.design.weight
        this.struct.life = this.struct.design.life
        this.struct.power = this.struct.design.power
        this.struct.sharers = this.struct.design.sharers
        this.struct.levels = this.struct.design.levels
        this.struct.standard = this.struct.design.standard
      }

      this.$events.fire(this.tableRef + '-refresh-table')
      this.$emit('update', (this.isAdding ? null : this.index), this.struct, this.isAdding)
      this.isAdding = false
    },

    onCancel () {
      this.disabled = true
    },

    onEdit () {
      this.disabled = false
    },

    onAdd () {
      this.onSave()
    },

    onSaveFail () {
//      this.$message ...
    },

    onSave () {

      if (this.supplier && this.supplier.id) {
        this.struct.supplier_id = this.supplier.id
      }

      this.saveForm(this, this.url, this.struct.id, this.struct, this.struct.type + (this.struct.subType ? ' / ' + this.struct.subType : ''), this.success, this.onSaveFail)
      this.disabled = true
    },

    onClose () {
    },

    deleteStruct () {
      this.deleteItem(this, this.struct.id, this.url, this.struct.name, this.onDelete)
    },

    onDelete (data) {
      this.$emit('delete', this.index, this.struct)
      this.$events.fire(this.tableRef + '-refresh-table')
    },

    supplierUpdated (id, sup) {

      console.log('id', id, 'sup', sup)

      if (this.isNumber(id) && this.isObject(sup)) {
        this.supplier = sup.data
      } else {
        this.supplier = id.data
      }

    }

  },



  computed: {
    url: function () {
      return (this.siteId ? '/site-struct' : '/struct')
    }
  },



  data () {

    return {
      menu: 'struct',
      clientName: this.xolasClient().name,
      isAdding: this.adding,
      disabled: true,
      supplier: this.rowData && this.rowData.supplier ? this.rowData.supplier : null,
      site: this.rowData && this.rowData.site ? this.rowData.site : null,
      struct: this.adding
        ? (this.siteId
          ? this.getTableStruct('site_structures')
          : this.getTableStruct('structures')
        ) : this.rowData
    }

  },



  created () {

    if (!this.struct) {
      this.struct = (this.siteId
        ? this.getTableStruct('site_structures')
        : this.getTableStruct('structures'))
    }

    if (this.isAdding) {
      this.disabled = false

      if (!this.siteId) {
        this.struct.category = 'Structure'
      }

      delete this.struct.id
    }

    if (this.siteId && !this.struct.site_id) {
      this.struct.site_id = this.siteId
      this.struct.supplier_id = (this.isTowerSupplierCo() ? this.org().id : null)
    }

  }

}
</script>



// WEBPACK FOOTER //
// StructDetails.vue?11dc2d30